import {
  StyledFullScreenContainer,
  StyledModalOverlay,
  StyledModalWrapper,
} from "@/mds/components/overlays/modal/modal.styles";
import { useMDSModalGlobalHotkeysBlocker } from "@/mds/components/overlays/modal/modal-global-hotkeys-blocker";
import { IMDSModalProps, MDSModalZIndex } from "@/mds/components/overlays/modal/modal.types";
import { Modal } from "react-aria-components";
import { useCallback } from "react";

export const MDSModal = ({
  zIndex = MDSModalZIndex.Default,
  handleClose,
  onOpenChange,
  isDismissable = true,
  ...props
}: IMDSModalProps) => {
  const useModalGlobalHotkeysBlocker = useMDSModalGlobalHotkeysBlocker();
  useModalGlobalHotkeysBlocker(!!props.isOpen);

  const handleOpenChange = (open: boolean) => {
    if (!open && isDismissable) {
      handleClose?.();
      onOpenChange?.(open);
    } else if (open) {
      onOpenChange?.(open);
    }
  };

  const handleOverlayClick = useCallback(() => {
    // Only close the modal if clicking directly on the overlay background,
    // not on floating elements like dropdowns that are rendered in portals
    if (isDismissable) handleClose?.();
  }, [isDismissable, handleClose]);

  const handleModalClick = useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // Eat clicks so the overlay doesn't capture the event.
    e.stopPropagation();
    return true;
  }, []);

  const forwardedProps = { isDismissable, onOpenChange: handleOpenChange, ...props };

  return (
    <StyledModalOverlay $zIndex={zIndex} {...forwardedProps} isDismissable={false}>
      <StyledFullScreenContainer onClick={handleOverlayClick}>
        <StyledModalWrapper onClick={handleModalClick}>
          <Modal>{forwardedProps.children}</Modal>
        </StyledModalWrapper>
      </StyledFullScreenContainer>
    </StyledModalOverlay>
  );
};
